module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0083.png.3a742001.jpg";